import styled, {css, keyframes} from 'styled-components';
import colors from '../../../theme/constants/colors';
import pxToRem from '../../../theme/helpers/pxToRem';
import {StyledProductCardSkeletonProps} from './typings';

const skeletonBgColor = colors.grey50;

const skeletonAnimation = keyframes`
  35% {
    opacity: 0.5;
  }
  75% {
    opacity: 1;
  }
`;

const skeletonBg = css`
  background: ${skeletonBgColor};
  animation: 2.5s ${skeletonAnimation} ease-in-out infinite;
`;

const skeletonText = (height: number, width: string, marginTop: number) => css`
  height: ${pxToRem(height)};
  width: ${width};
  border-radius: 0;
  ${skeletonBg}
  margin-top: ${marginTop}px;
`;

const StyledProductCardSkeleton = styled.div<StyledProductCardSkeletonProps>`
  background-color: #fff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  width: 260px;
  overflow: hidden;

  & figure {
    padding-bottom: 70%;
    ${skeletonBg}
    margin: 0;
    ${(props) =>
      props.$aspectRatio &&
      css`
        aspect-ratio: ${props.$aspectRatio};
      `}
  }

  > section {
    padding: 8px 10px;
  }
`;

export const StyledTitle = styled.div`
  ${skeletonText(20, '70%', 0)}
  animation-delay: 0.5s;
`;

export const StyledCategory = styled.div`
  ${skeletonText(15, '40%', 7)}
  animation-delay: 0.5s;
`;

export const StyledSize = styled.div`
  ${skeletonText(10, '30%', 7)}
  animation-delay: 0.5s;
`;

export const StyledPrice = styled.div`
  ${skeletonText(25, '45px', 15)}
  animation-delay: 1s;
`;

export default StyledProductCardSkeleton;
